var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoad)?_c('div',{staticClass:"poster"},[_c('div',{staticClass:"title"},[_vm._v("恭喜你！")]),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.imgPath,"width":"300px"}})]),(!_vm.posterUrl)?_c('clazz-card',{ref:"clazzPoster",attrs:{"poster-data":_vm.posterData},on:{"success":_vm.success,"fail":_vm.fail}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }